import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { SHOW_PHONE_CONTACT, WHATSAPP_URL } from "./lib/contact";

export default function Layout({ children }) {
  const location = useLocation();

  // Don't show Navbar on home page (it has its own navbar integrated)
  const showNavbar = location.pathname !== "/";

  return (
    <div className="min-h-screen bg-black">
      {showNavbar && <Navbar />}
      <main className="overflow-hidden">{children}</main>
      <Footer />
      {SHOW_PHONE_CONTACT && (
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="h-8 w-8"
        >
          <path d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.55 0 .26 5.29.26 11.8c0 2.08.54 4.11 1.58 5.9L0 24l6.5-1.7a11.76 11.76 0 0 0 5.56 1.42h.01c6.5 0 11.79-5.3 11.79-11.81 0-3.15-1.23-6.11-3.34-8.43ZM12.07 21.7h-.01a9.8 9.8 0 0 1-5-1.38l-.36-.22-3.86 1.01 1.03-3.75-.24-.39a9.77 9.77 0 0 1-1.5-5.2c0-5.4 4.4-9.8 9.81-9.8 2.61 0 5.06 1.01 6.9 2.85a9.72 9.72 0 0 1 2.88 6.95c0 5.4-4.4 9.8-9.8 9.8Zm5.38-7.35c-.3-.15-1.8-.88-2.08-.98-.28-.1-.48-.15-.68.15-.2.3-.77.97-.95 1.17-.18.2-.35.23-.65.08-.3-.15-1.25-.46-2.38-1.46-.88-.78-1.48-1.74-1.65-2.04-.18-.3-.02-.47.13-.62.14-.14.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.68-1.65-.93-2.26-.25-.6-.5-.52-.68-.52h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.02-1.05 2.48s1.08 2.86 1.23 3.06c.15.2 2.13 3.25 5.16 4.55.72.31 1.28.5 1.72.63.72.23 1.38.2 1.9.12.58-.08 1.8-.73 2.05-1.44.25-.7.25-1.3.18-1.43-.08-.12-.28-.2-.58-.35Z" />
        </svg>
      </a>
      )}
    </div>
  );
}
